import { Line } from './line.model';

export class ValueStreamConfiguration {

    public id: number;
    public valueStreamName: string;
    public emailAddress: string;
    public lines: Line[];

    constructor(resource: any = {}) {
        this.id = resource.id || 0;
        this.valueStreamName = resource.valueStreamName || '';
        this.emailAddress = resource.emailAddress || '';
        this.lines = resource.lines ? resource.lines : [];
    }

    get type() {
        return 'value-stream-configuration';
    }
}
